import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Dashboard from "./pages/Index"
import Cases from "./pages/Cases"
import CaseDetails from "./pages/CaseDetails"
import NewCase from "./pages/NewCase"
import Login from "./pages/Login"
import NotFound from "./pages/NotFound"
import ProtectedRoute from "./lib/ProtectedRoute"
import { UploadProvider } from "./UploadProvider"
import GlobalUploadIndicator from "./components/upload/GlobalUploadIndicator"
import UploadQueueModal from "./components/upload/UploadQueueModal"
import { useState } from "react"

const queryClient = new QueryClient()

const App = () => {
	const [isUploadQueueModalOpen, setIsUploadQueueModalOpen] = useState(false)

	const toggleUploadQueueModal = () => {
		setIsUploadQueueModalOpen((prev) => !prev)
	}

	return (
		<QueryClientProvider client={queryClient}>
			<TooltipProvider>
				<Toaster />
				<Sonner />
				<UploadProvider>
					<BrowserRouter>
						<Routes>
							<Route path="/login" element={<Login />} />
							<Route element={<ProtectedRoute />}>
								<Route path="/" element={<Dashboard />} />
								<Route path="/cases" element={<Cases />} />
								<Route path="/cases/new" element={<NewCase />} />
								<Route path="/cases/:id" element={<CaseDetails />} />
							</Route>
							<Route path="*" element={<NotFound />} />
						</Routes>
					</BrowserRouter>
					<div onClick={toggleUploadQueueModal} style={{ cursor: "pointer" }}>
						<GlobalUploadIndicator />
					</div>
					<UploadQueueModal
						isOpen={isUploadQueueModalOpen}
						onClose={toggleUploadQueueModal}
					/>
				</UploadProvider>
			</TooltipProvider>
		</QueryClientProvider>
	)
}

export default App
